import { create } from 'zustand';

export type ToastType = 'success' | 'error' | 'info';

export interface ToastAction {
  label: string;
  onClick: () => void;
}

interface ToastItem {
  id: number;
  message: string;
  type: ToastType;
  action?: ToastAction;
}

interface ToastStore {
  toasts: ToastItem[];
  show: (message: string, type?: ToastType, action?: ToastAction) => void;
  dismiss: (id: number) => void;
}

const DEFAULT_DURATION_MS = 4000;
const ACTION_DURATION_MS = 7000;

let nextId = 1;

export const useToastStore = create<ToastStore>((set) => ({
  toasts: [],
  show: (message, type = 'info', action) => {
    const id = nextId++;
    set((s) => ({ toasts: [...s.toasts, { id, message, type, action }] }));
    setTimeout(
      () => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
      action ? ACTION_DURATION_MS : DEFAULT_DURATION_MS
    );
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));
